import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectScenarioExportRedirect = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectScenarioExportRedirect />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectScenarioExportRedirect = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectScenarioExportRedirect />
    </Suspense>
  );
};
